import { Apis } from "../../lib/Apis";

export const useContracts = () => {
    const createContract = async (contractData) => {
        try {
            const response = await Apis.postContract(contractData);
            return response.data;
        } catch (error) {
            console.error("Error creating contract:", error);
            throw error;
        }
    }
    const getContracts = async () => {
        try {
            const response = await Apis.getContracts();
            return response.data;
        } catch (error) {
            console.error("Error fetching contracts:", error);
            throw error;
        }
    }
    const getContractById = async (id) => {
        try {
            const response = await Apis.getContractById(id);
            return response.data;
        } catch (error) {
            console.error("Error fetching contract:", error);
            throw error;
        }
    }
    const deleteContract = async (id) => {
        try {
            const response = await Apis.deleteContract(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting contract:", error);
            throw error;
        }
    }
    const updateContract = async (id, data) => {
        try {
            const response = await Apis.updateContract(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating contract:", error);
            throw error;
        }
    }
    const getUserContracts = async (params) => {
        try {
            const response = await Apis.getUserContracts(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching user contracts:", error);
            throw error;
        }
    }
    return { createContract, getContracts, deleteContract, getContractById, updateContract, getUserContracts };
}
